module.exports = __webpack_public_path__ + "frontend/images/cards/green/green@2.png?2abc8d9b5e288b1e1143e1568fe5c5da";